import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { AccumulationsExpireItem } from '../../@types/profile'
import '../../css/myshopping.css'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import { plusComma } from '../../js/script'

/**
 * 모달 팝업 - 섬 모양
 *
 * @params content - 콘텐츠 내용
 */

export default function CoinExpireModal({
  setCoinExpireModal,
  expiresAmount,
  items,
}: {
  setCoinExpireModal: React.Dispatch<React.SetStateAction<boolean>>
  expiresAmount: number
  items: AccumulationsExpireItem[]
}) {
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      setCoinExpireModal(false)
      setClosing(false)
    }, 280)
  }

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  // if (!isModal) return null;
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <div className='coin_expected_expire'>
          <ModalHeader>
            <div className='title'>
              <p>소멸 예정 적립금 (30일 이내)</p>
              {/* 닫기 버튼 */}
              <button onClick={closeModal}>
                <img src='../images/icon_close.png' alt='닫기 버튼' />
              </button>
            </div>
          </ModalHeader>
          <ModalBody>
            {items.length !== 0 ? (
              <div className='list'>
                <dl className='title'>
                  <dt>소멸 예정일</dt>
                  <dd>적립금</dd>
                </dl>
                {items.map((el: any, index: number) => (
                  <dl key={index}>
                    <dt>{el.expirationYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}</dt>
                    <dd>{plusComma(-el.amount)}</dd>
                  </dl>
                ))}
                <div className='sum'>
                  <dl>
                    <dt>총 소멸 예정 적립금</dt>
                    <dd>{plusComma(expiresAmount)}</dd>
                  </dl>
                </div>
              </div>
            ) : (
              <div className='no_list'>소멸 예정 적립금이 없습니다.</div>
            )}
          </ModalBody>
        </div>
      </ModalBox>

      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  )
}

interface typeProps {
  closing?: boolean
}

export const ModalBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
`

export const ModalBox = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  max-height: 80vh; // 높이 제한 추가
  background-color: var(--colWhite);
  margin: 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: fixed;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 18px;
  border-radius: 22px 22px 0 0;
  bottom: 0;
  left: 0;
  overflow-y: auto; // 스크롤 추가
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s;
`

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 18.5px 22px 0 33px;
  & .title button {
    width: 41px;
    height: 48px;
    padding: 12px 8px 12px 9px;
    & img {
      width: 100%;
      height: 100%;
    }
  }
`

export const ModalBody = styled.div`
  padding: 16px 33px 32px 33px;
  overflow-y: auto;
  max-height: 50vh; // 원하는 값으로 조정
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`
